import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { Transition } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { MailUnsubscribeComponent } from './unsubscribe/mail-unsubscribe.component';
import { NgModule } from '@angular/core';
import { MailDataService } from './mail-data.service';
import { MailComponent } from './mail.component';
import { GaStateDeclaration } from '../../type_definitions/datatypes';

const states:GaStateDeclaration[] = [
  {
    name: 'mail',
    url: '/mail',
    abstract: true,
    views: {
      main: {
        component: MailComponent
      }
    }
  },
  {
    name: 'mail.unsubscribe',
    url: '/unsubscribe?deconid&ukey',
    component: MailUnsubscribeComponent,
    resolve: [
      {
        token: 'deconid',
        deps: [ Transition ],
        resolveFn: (transition:Transition) => transition.params()?.deconid
      },
      {
        token: 'token',
        deps: [ Transition ],
        resolveFn: (transition:Transition) => transition.params()?.ukey
      }
    ]
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    SharedModule
  ],
  declarations: [
    MailComponent,
    MailUnsubscribeComponent
  ],
  providers: [
    MailDataService
  ]
})
export class MailModule {
}